import { globalConstants } from "../../constants";
import { SEND_MESSAGE } from "../../constants/contactUs.constants";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";
import { contactUsService } from "../../services";
import { customToast } from "../../shared/utility";
import { custom } from "./utilities";

const contactUs =
  (body, successFunc = () => {}) =>
  (dispatch) => {
    dispatch(custom(SEND_MESSAGE, globalConstants.SPINNER_ACTIVATE));
    contactUsService
      .contactUs(body)
      .then(
        (response) => {
          customToast(response.msg, SUCCESS_TOAST);
          successFunc();
        },
        (error) => customToast(error[0], ERROR_TOAST)
      )
      .finally(() =>
        dispatch(custom(SEND_MESSAGE, globalConstants.SPINNER_DIACTIVATE))
      );
  };

export const contactUsActions = {
  contactUs,
};
